import React from 'react';

interface PortalPageHeaderProps {
  title: string;
  description: string;
  context?: React.ReactNode;
  actions?: React.ReactNode;
  helpHref?: string;
  helpLabel?: string;
}

/** Shared Portal page heading, context and command surface. */
export const PortalPageHeader = ({
  title,
  description,
  context,
  actions,
  helpHref,
  helpLabel = 'Help'
}: PortalPageHeaderProps): JSX.Element => (
  <header className="portal-page-header">
    <div className="portal-page-header__copy">
      <h1 className="section-title">{title}</h1>
      <p className="muted portal-page-header__description">{description}</p>
    </div>
    {(actions || helpHref) && (
      <div className="portal-page-header__actions" aria-label={`${title} actions`}>
        {actions}
        {helpHref && (
          <a className="btn secondary" href={helpHref}>
            {helpLabel}
          </a>
        )}
      </div>
    )}
    {context && <div className="portal-page-header__context">{context}</div>}
  </header>
);
